import { GameObjectPool } from './utils/GameObjectPool';
import type { BoosterDefinitions } from './boosters/types';
import { BoosterType } from './boosters/types';

export const GAME_OBJECT_POOL = new GameObjectPool();

export enum ReviveReason {
  Coins = 'coins',
  Ad = 'ad',
  SpecialOffer = 'specialOffer',
}

interface EconomySettings {
  initialCoinBalance: number;
  reviveCoinCost: number;
  reviveSpacesCleared: Record<ReviveReason, number>;
  refillLifeCoinCost: number;
  piggyBankCoinCapacity: number;
  freeShopGiftCoinReward: number;
  boosters: BoosterDefinitions;
}

export const GAME_ECONOMY_SETTINGS: EconomySettings = {
  initialCoinBalance: 1000,
  reviveCoinCost: 900,
  reviveSpacesCleared: {
    [ReviveReason.Ad]: 4,
    [ReviveReason.Coins]: 4,
    [ReviveReason.SpecialOffer]: 4,
  },
  refillLifeCoinCost: 900,
  piggyBankCoinCapacity: 3000,
  freeShopGiftCoinReward: 50,
  boosters: {
    [BoosterType.Hammer]: {
      type: BoosterType.Hammer,
      name: 'Hammer',
      description: 'Clears an object on the board',
      unlockLevel: 3,
      coinCost: 1650,
    },
    [BoosterType.Move]: {
      type: BoosterType.Move,
      name: 'Move',
      description: 'Move a stack to any space or swap with another stack',
      unlockLevel: 5,
      coinCost: 1300,
    },
    [BoosterType.Redraw]: {
      type: BoosterType.Redraw,
      name: 'Redraw',
      description: 'Redraw the stacks in the tray',
      unlockLevel: 8,
      coinCost: 650,
    },
    [BoosterType.Undo]: {
      type: BoosterType.Undo,
      name: 'Undo',
      description: 'Undo your last move',
      unlockLevel: 11,
      coinCost: 2000,
    },
  },
};
